document.addEventListener('DOMContentLoaded', function () {
  function subscribeEmailToConnectif(email) {
  if (!email || !window.connectif || !window.connectif.managed) {
    console.log('Connectif no disponible o email vacío:', email);
    return;
  }

  console.log('Enviando a Connectif:', email);

  window.connectif.managed.sendEvents(
    [
      {
        type: 'newsletter-subscribe',
        email: email
      }
    ],
    {
      entityInfo: {
        email: email
      },
      onResponded: function () {
        console.log('Connectif ha respondido al envío del evento');
      }
    }
  );
}

  function patchGrowtypeCallback() {
    if (!window.initVar || typeof window.initVar.campaignPopUpNotifyButtonClicked !== 'function') {
      return false;
    }

    if (window.initVar.__connectifPatched) {
      return true;
    }

    window.initVar.__connectifPatched = true;

    const originalFn = window.initVar.campaignPopUpNotifyButtonClicked.bind(window.initVar);

    window.initVar.campaignPopUpNotifyButtonClicked = function (iframeId, workflowId, payload, optInToMarketing) {
      console.log('Growtype payload recibido:', {
        iframeId: iframeId,
        workflowId: workflowId,
        payload: payload,
        optInToMarketing: optInToMarketing
      });

      try {
        if (typeof payload === 'string') {
          const email = payload.trim();
          if (email) {
            subscribeEmailToConnectif(email);
          }
        }
      } catch (e) {
        console.error('Error enviando a Connectif:', e);
      }

      return originalFn(iframeId, workflowId, payload, optInToMarketing);
    };

    console.log('Patch aplicado sobre initVar.campaignPopUpNotifyButtonClicked');
    return true;
  }

  const interval = setInterval(function () {
    if (patchGrowtypeCallback()) {
      clearInterval(interval);
    }
  }, 300);
});